'use client';

import { useState } from 'react';

interface SessionTabItemProps {
  item: ISessionTabItem;
  active: boolean;
  onChange?: (props: { id: string }) => void;
}
const SessionTabItem = ({
  item,
  active = false,
  onChange,
}: SessionTabItemProps) => {
  const { timeText, id, title } = item;
  return (
    <div
      className={`w-[329px] min-h-[119px] relative px-[24px] py-4 border-l border-solid border-[#C4CDFF] hover:bg-[linear-gradient(90deg,#4E89FF_0%,#9BAFFF_70%,#9AA0FF00_100%)] cursor-pointer group ${
        active
          ? 'bg-[linear-gradient(90deg,#4E89FF_0%,#9BAFFF_70%,#9AA0FF00_100%)] text-white'
          : 'text-[#121C59]'
      }`}
      onClick={() => {
        onChange?.({ id });
      }}
    >
      <div className="text-[24px] leading-[1.5] font-tcn1 group-hover:text-white">
        {timeText}
      </div>
      <div className="text-[18px] leading-[1.5] mt-6 break-words hyphens-auto font-300 opacity-60 group-hover:text-white">
        {title}
      </div>
    </div>
  );
};

interface ISessionTabItem {
  id: string;
  timeText: string;
  title: string;
}

const SessionTabList = ({
  defaultActive,
  list,
  onChange,
}: {
  list: ISessionTabItem[];
  defaultActive?: string;
  onChange: (props: { id: string }) => void;
}) => {
  const [activeKey, setActiveKey] = useState(defaultActive || list[0]?.id);
  return (
    <div className="relative flex flex-col gap-[16px]">
      {list.map((item) => (
        <SessionTabItem
          item={item}
          key={item.id}
          active={activeKey === item.id}
          onChange={({ id }) => {
            setActiveKey(item.id);
            onChange({ id });
          }}
        ></SessionTabItem>
      ))}
    </div>
  );
};

export default SessionTabList;
